export default __webpack_public_path__ + "static/media/t4.min.61e2f535.png";